<template>
  <nuxt-layout name="www">
    <u-app>
      <client-only>
        <div class="absolute" id="loading-completed">
          <span class="opacity-0">-</span>
        </div>
      </client-only>
      <nuxt-page />
    </u-app>
  </nuxt-layout>
</template>
<script lang="ts">
import * as definitions from "~/definitions";
export default {
  setup() {
    definitions.seo.set.index.fn();
  }
};
</script>
